<template>
    <div>
        <!-- 筛选条件 工具栏-->
        <div class="filter-box">
            <div class="filter-container">
                <!-- <div class="label filter-item" style="margin-right:20px; font-weight: bold;">筛选条件</div> -->

                <!-- 搜索 -->
                <div class="filter-data" v-if="source == 'team' || source == 'recycle'">
                    <!-- <div class="label filter-item">搜索：</div> -->
                    <el-input class="filter-item" size="small" v-model="search" clearable placeholder="文件名模糊查找" style="width:200px" @keyup.enter.native="handleFile" @input="handleFile">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>

                <!-- 创建时间-->
                <div class="filter-data">
                    <div class="label filter-item">上传时间：</div>
                    <el-date-picker size="small" class="filter-item" v-model="createTime" type="daterange"  format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="center" unlink-panels range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" style="width:260px" @change="handleFile"></el-date-picker>
                </div>

                <template v-if="source == 'allMaterial'">
                    <!-- 项目选择-->
                    <div class="filter-data">
                        <div class="label filter-item">项目：</div>
                        <el-select class="filter-item" size="small" v-model="projectIds" multiple collapse-tags filterable clearable placeholder="请选择" style="width:210px;" @change="handleFile">
                            <el-option v-for="(item,index) in projectOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>

                    <!-- 渠道选择-->
                    <!-- <div class="filter-data">
                        <div class="label filter-item">渠道：</div>
                        <el-select class="filter-item" size="small" v-model="channelIds" multiple collapse-tags filterable clearable placeholder="请选择">
                            <el-option v-for="(item,index) in channelOptions" :key="index" :label="item" :value="item"></el-option>
                        </el-select>
                    </div> -->

                    <!-- 尺寸选择-->
                    <!-- <div class="filter-data">
                        <div class="label filter-item">尺寸：</div>
                        <el-select class="filter-item" size="small" v-model="size" filterable clearable placeholder="请选择">
                            <el-option v-for="(item,index) in sizeOptions" :key="index" :label="item" :value="item"></el-option>
                        </el-select>
                    </div> -->

                    <!-- 设计师-->
                    <div class="filter-data">
                        <div class="label filter-item">设计师：</div>
                        <el-select class="filter-item" size="small" v-model="designerIds" multiple collapse-tags filterable clearable placeholder="请选择" style="width:210px;" @change="handleFile">
                            <el-option v-for="(item,index) in designerOptions" :key="index" :label="item.realname" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </template>
            </div>
            <!-- 展开 关闭 -->
            <el-button v-if="source == 'allMaterial'" class="arrowButn" type="text" size="mini"  @click="isAllShow=!isAllShow">{{isAllShow?'收起':'展开'}}<i class="el-icon--right" :class="isAllShow ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></el-button>
        </div>

        <!-- 分类选择 工具栏-->
        <el-tabs v-if="source == 'allMaterial' && isAllShow" type="border-card" class="border-card">
            <!-- <el-tab-pane label="分类选择"> -->
                <template  >
                    <div class="list" v-for="(item,index) in selectList" :key="index" v-show="item.isShow" :class="item.isMore || item.isCheckbox? 'moreHeight' : ''">
                        <label class="title">{{item.labelName}}：</label>
                        <div class="item-box" :ref="'tagbox_'+index">
                            <el-radio-group class="itemTag" size="mini" v-model="item.radios" v-if="!item.isCheckbox" @change="changeRadios(item)">
                                <el-radio-button v-show="(typeIndex<= 12 && !item.isMore) || item.isMore" v-for="(typeItem,typeIndex) in item.labelList" :label="typeItem.id" :key="typeIndex">{{typeItem.name}}</el-radio-button>
                            </el-radio-group>

                            <el-checkbox-group class="itemTag" size="small" v-model="item.checkeds" v-else>
                                <el-checkbox v-for="(typeItem,typeIndex) in item.labelList" :label="String(typeItem.id)" :key="typeIndex">{{typeItem.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="butn-box" v-if="!item.isCheckbox">
                            <el-button size="mini" icon="el-icon-plus" @click="item.isCheckbox = true">多选</el-button>
                            <el-button size="mini" type="text" v-if="item.labelList.length > tagWidth / 120" @click="item.isMore = !item.isMore">{{item.isMore ? '收起' : '更多'}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        </div>
                        <div class="butn-box" v-else-if="item.isCheckbox">
                            <el-button size="mini" type="danger" @click="handleSubmit(item)" v-if="item.checkeds.length > 0">确认</el-button>
                            <el-button size="mini" @click="handleCancel(item)">取消</el-button>
                        </div>
                    </div>
                </template>
            <!-- </el-tab-pane> -->
            
        </el-tabs>
    </div>
</template>

<script>
import { parseTime } from '@/utils'
import {designerList_ajax, projectList_ajax, labelList_ajax} from '@File~/api/file'
export default {
    props: {
        source: {
            type:String,
            default: ''
        }
    },
    data() {
        return {
            search:'',
            createTime: [], // 时间范围
            // 时间范围 快捷键
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime());
                            picker.$emit('pick', [start, end]);
                        }
                    },

                    {
                        text: '昨天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '过去7天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去14天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去30天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                // 当前日期之前的日期不可选
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            projectIds:'',
            projectOptions:[],
            // channelIds:'',
            // channelOptions:['360','4399','OPPO'],
            // size:'',
            // sizeOptions:['720*360', '672*246', '400*400'],
            designerIds:'',
            designerOptions:[],
            selectList: [],   // 筛选列表            
           
            isAllShow: true,

            resultSelected:[], // 最终筛选数据

            tagWidth:1000
        }
    },

    created() {
        if(this.source == 'allMaterial') {
            this.getProject() // 项目列表接口
            this.getDesigner() // 设计师列表接口
            this.getLabel() // 用途列表
        }
    },

    mounted() {
        if(this.source == 'allMaterial') {
            window.addEventListener('resize',() => {
                this.tagWidth = this.$refs.tagbox_0[0].clientWidth
            })
        }
    },

    methods: {
        // 项目列表
        getProject() {
            projectList_ajax().then(response => {
                if(response.code == 1) {
                    this.projectOptions = response.data
                }
            })
        },

        // 设计师列表接口
        getDesigner() {
            designerList_ajax().then(response => {
                if(response.code == 1) {
                    this.designerOptions = response.data
                }
            })
        },

        // 用途列表接口
        getLabel() {
            labelList_ajax().then(response => {
                if(response.code == 1) {
                    const data = JSON.parse(JSON.stringify(response.data))
                    this.selectList = data.map(v => {
                        v.isShow = true
                        v.isCheckbox = false
                        v.isMore = false
                        v.radios = ''
                        v.checkeds = []
                        // this.$set(v, )
                        return v
                    })
                    this.$nextTick(() => {
                        this.tagWidth = this.$refs.tagbox_0[0].clientWidth
                    })

                }
            })
        },

        // 回溯 selectList
        recallSelectList(tag) {
            if(tag) {
                console.log('====',tag)
                this.selectList.forEach(item => {
                    if( tag.labelType == item.labelType) {
                        item.isShow = true
                    }
                })
            } else {
                this.resultSelected = []
                this.selectList.forEach(item => {
                    item.isShow = true
                })
            }

            this.$emit('filterSubmit', this.resultSelected)
            
            // console.log(this.selectList)
        },

        // 监听单选
        changeRadios(item) {
            item.isShow = false
            this.resultChecked(item,"radios")
            this.$nextTick(() => {
                item.radios = ''
            })
        },

        // 最终提交已选数据
        resultChecked(item,type) {
            let result = []
            if(type == 'radios') {
                item.labelList.forEach(list => {
                    if(item.radios == list.id) {
                        result.push(list)
                    }
                })
            } else {
                item.checkeds.forEach(checked => {
                    item.labelList.forEach(list => {
                        if(checked == list.id) {
                            result.push(list)
                        }
                    })
                })
            }
            
            const data = {
                labelType:item.labelType,
                labelName: item.labelName,
                list: result,
                checkeds: type == 'radios' ? [item.radios] : item.checkeds
            }

            this.resultSelected.push(data)

            console.log('最终选中结果：',this.resultSelected)

            this.$emit('filterSubmit', this.resultSelected)
        },

         // 提交多选
        handleSubmit(item) {
            this.resultChecked(item,'checkeds')
            item.isShow = false

            this.$nextTick(() => {
                item.isCheckbox = false
                item.checkeds = []
                item.radios = ''
            })
        },

        // 取消多选
        handleCancel(item) {
            item.isCheckbox = false
            this.$nextTick(() => {
                item.isCheckbox = false
                item.checkeds = []
                item.radios = ''
                item.value = []
            })
        },

        // 筛选
        handleFile() {
            if(this.source == 'allMaterial') {
                this.$emit('filterSubmit', this.resultSelected)
            } else {
                this.$emit('filterSubmit')
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
    .filter-box{
        margin: 5px 0;
        padding: 10px 10px 0px 20px;
        background: #ffffff;
        box-shadow: 0 0 2px inset rgba(0,0,0,.28);
        border-radius: 5px;
        position: relative;
        .arrowButn{
            position:absolute;
            top: 10px;
            right: 10px;
            width: 60px;
            height:26px;
        }
    }
    .filter-container {
        margin-right: 70px;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content:flex-start;
       
        .filter-data {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
        }
        .label {
            font-size: 15px;
            margin-right: 3px;
            color: #7b7b7b;
        }

        ::v-deep .el-select__tags{
            .el-tag {
                max-width: 75%;
                overflow: hidden;
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;
                .el-select__tags-text{
                    width: 100%;
                    overflow: hidden;
                }
            }
            .el-select__input{
                margin-left: 2px;
            }
        }
    }

    .border-card{
        .list{
            display: flex;
            flex-flow: row wrap;
            justify-content: flex-start;
            align-items: flex-start;
            border-bottom: 1px dashed #ccc;
            margin-bottom: 5px;
            padding-bottom: 5px;
            height: 32px;
            overflow: hidden;

            &.moreHeight{
                height: auto;
            }

            ::v-deep .el-radio-button__inner{
                border: 0;
            }  
            ::v-deep .el-radio-button:first-child .el-radio-button__inner, ::v-deep .el-radio-button:last-child .el-radio-button__inner{
                border-radius: 0;
            }
            ::v-deep .el-checkbox{
                line-height: 26px;
            }
            .title{
                margin-right: 20px;
                width: 84px;
                line-height: 26px;
                font-size: 14px;
                font-weight: normal;
                color: #aeaeae;
                text-align: right;
            } 
            .butn-box{
                width: 130px;
                ::v-deep .el-button--mini{
                   padding: 4px 8px; 
                }
                ::v-deep .el-button+.el-button{
                    margin-left: 4px;
                }
            }
            .item-box{
                flex: 2;
            }
        }
        ::v-deep.el-tabs__content{
            padding-bottom: 5px;
        }
        .itemTag{
            label{
                width: 120px;
            }
           
        }
    }
</style>